<template>
  <div class="noni_scartchcard">
    <transition name="fade">
      <!-- The Modal -->
      <div id="myModal" class="modal" v-if="modal">
        <!-- Modal content -->
        <div class="modal-content">
          <div style="padding: 20px">
            <span class="close" @click="modal = !modal">&times;</span>
            <h3 style="text-align: center">Finding Amazon Review Permalink</h3>
          </div>

          <div>
            <p>
              1. Go to Public Reviews Written by You:&nbsp;&nbsp;<a
                href="https://www.amazon.com/gp/cdp/member-reviews/"
                target="_blank"
                rel="noopener"
                >https://www.amazon.com/gp/cdp/member-reviews/</a
              >
            </p>
            <p>
              2. This page lists the reviews accepted by Amazon that you’ve
              written. Search through each page until you find the review you’re
              looking for. Once you’ve found the review you’re searching for,
              beneath your review you will see two web links. One reads,
              “Comment,” the other, “Permalink.” Click on the “Permalink” web
              link.
              <img
                class="alignnone size-full wp-image-13906"
                :src="
                  plugin_dir_url +
                  '../public/images/Finding-Amazon-Review-Permalink1.jpg'
                "
                alt=""
                width="1000"
                height="480"
              />
            </p>
            <p>
              3. At the top of the screen, the URL in your browser should now
              display the “Permalink” to that review. Any time a person types in
              this exact permalink, it should take them directly to this page.
              <img
                class="alignnone size-full wp-image-13905"
                :src="
                  plugin_dir_url +
                  '../public/images/Finding-Amazon-Review-Permalink-2.jpg'
                "
                alt=""
                width="1000"
                height="480"
              />
            </p>
            <p>
              4. To copy link, highlight the entire URL at the top of the screen
              in your browser. You can either right-click the highlighted words
              and select copy from the drop-down menu, or you can press
              “Control” and “C” on your keyboard simultaneously (or Command-C if
              you’re on a Mac).
            </p>

            <div class="clear"></div>

            <p class="noni-center">
              <button
                class="noni-vip-submit btn primary btn-lg"
                @click="modal = !modal"
              >
                Close
              </button>
            </p>
          </div>
        </div>
      </div>
    </transition>
    <form
      id="noni_redeem_form"
      action="<?php admin_url('admin-ajax.php'); ?>"
      class="noni_gift_form"
      method="post"
      @submit.prevent
      v-if="!sent"
    >
      <p v-if="country_selection">
        <label>
          {{ country_label }}* <br />
          <select
            class="select-css"
            v-model="form.country"
            v-validate="'required'"
            data-vv-validate-on="blur"
            type="text"
            name="country"
          >
            <option
              :value="country.code"
              v-for="country in countries"
              :key="country.code"
            >
              {{ country.name }}
            </option>
          </select>
          <span :class="{ invalid: errors.has('country') }" class="danger">{{
            errors.first("country")
          }}</span>
        </label>
      </p>
      <p>
        <label>
          {{ product_label }}?* <br />

          <select
            v-if="products.length > 0"
            class="select-css"
            v-model="form.product"
            v-validate="'required'"
            data-vv-validate-on="blur"
            type="text"
            name="product"
          >
            <option
              v-for="product in products"
              :key="product.id"
              :value="product.product"
            >
              {{ product.product }}
            </option>
          </select>
          <input
            v-else
            v-model="form.product"
            v-validate="'required'"
            data-vv-validate-on="blur"
            type="text"
            name="product"
          />
          <span :class="{ invalid: errors.has('product') }" class="danger">{{
            errors.first("product")
          }}</span>
        </label>
      </p>
      <p>
        <label>
          {{ order_id_label }}* <br />
          <input
            v-model="form.order_id"
            v-validate="'required'"
            data-vv-validate-on="blur"
            type="text"
            name="order_id"
          />
          <span :class="{ invalid: errors.has('order_id') }" class="danger">{{
            errors.first("order_id")
          }}</span>
        </label>
      </p>
      <p>
        <label>
          {{ permalink_label }}* <br />
          <input
            v-model="form.permalink"
            v-validate="'required'"
            data-vv-validate-on="blur"
            type="text"
            name="permalink"
          />
          <span :class="{ invalid: errors.has('permalink') }" class="danger">{{
            errors.first("permalink")
          }}</span>

          <br /><span style="font-size: 0.8em"
            ><a @click="modal = !modal" href="javascript:void(0)">Click here</a>
            if you're not sure how to find your review permalink.</span
          >
        </label>
      </p>
      <p>
        <label>
          {{ reimbursed_method_label }}* <br />
          <select
            v-model="form.reimbursed_method"
            name="reimbursed_method"
            class="select-css"
          >
            <!-- <option  value="PayPal">PayPal</option> -->
            <option value="Amazon Giftcard">Amazon Giftcard</option>
          </select>
          <span
            :class="{ invalid: errors.has('reimbursed_method') }"
            class="danger"
            >{{ errors.first("reimbursed_method") }}</span
          >
        </label>
      </p>
      <p v-if="form.reimbursed_method == 'PayPal'">
        <label>
          {{ paypal_email_label }}* <br />
          <input
            v-model="form.paypal_email"
            v-validate="'required'"
            name="paypal_email"
            data-vv-validate-on="blur"
            type="email"
          />
          <span
            :class="{ invalid: errors.has('paypal_email') }"
            class="danger"
            >{{ errors.first("paypal_email") }}</span
          >
        </label>
      </p>
      <p>
        <label>
          {{ vip_email_label }}* <br />
          <input
            v-model="form.vip_email"
            v-validate="'required'"
            name="vip_email"
            data-vv-validate-on="blur"
            type="email"
          />
          <span :class="{ invalid: errors.has('vip_email') }" class="danger">{{
            errors.first("vip_email")
          }}</span>
        </label>
      </p>
      <p class="noni-center">
        <button
          class="noni-scratchcard-submit btn primary btn-lg"
          @click="send()"
          :disabled="loading"
        >
          <span v-if="loading"> Sending </span>
          <span v-else> Send </span>
        </button>
      </p>
    </form>
    <div v-else class="noni-message" ref="message">
      <h3>
        Thanks for reviewing our product! We will get in touch with you shortly
        about your redeem information.
      </h3>
    </div>
  </div>
</template>

<script>
var Qs = require("qs");
import Swal from "sweetalert2";
import CONSTANTS from "../constants";
export default {
  name: "RedeemForm",
  data: () => ({
    loading: false,
    form: {
      ajax_nonce: window.ajax_object.ajax_nonce,
      product: "",
      order_id: "",
      permalink: "",
      reimbursed_method: "Amazon Giftcard",
      paypal_email: "",
      vip_email: "",
      action: "vip_redeem_form_submission",
      country: "US",
    },
    country_selection: true,
    sent: false,
    countries: CONSTANTS.COUNTRIES,
    country_label: "Country",
    product_label: "Which product did you review",
    order_id_label: "Amazon Order ID",
    permalink_label: "Amazon Review Permalink",
    reimbursed_method_label: "PayPal",
    paypal_email_label: "How would you like to be reimbursed?",
    vip_email_label: "What is your PayPal Email Address?",

    products: [],
    modal: false,
  }),
  watch: {
    "form.country": function (val) {
      if (val == "DE") {
        this.setGerman();
      } else {
        this.setEnglish();
      }
    },
  },
  computed: {
    // a computed getter
    plugin_dir_url: function () {
      // `this` points to the vm instance
      return window.ajax_object.plugin_dir_url;
    },
  },
  mounted: function () {
    this.getProducts();
    this.axios
      .get(
        "https://api.ipdata.co?api-key=05ac003d8a8be6675badabe27f1e726c6925a6ffb611ce0abcf2f7db"
      )
      .then((response) => {
        this.form.country = response.data.country_code;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {
    setEnglish() {
      this.$validator.localize("en", {
        attributes: {
          paypal_email: "PayPal Email",
          vip_email: "VIP Email",
          reimbursed_method: "Reinbursment Method",
          permalink: "Review Link",
          order_id: "Order ID",
          country: "Country",
          product: "Product",
        },
      });
      this.country_label = "Country";
      this.product_label = "Which product did you review";
      this.order_id_label = "Amazon Order ID";
      this.permalink_label = "Amazon Review Permalink";
      this.reimbursed_method_label = "How would you like to be reimbursed?";
      this.paypal_email_label = "What is your PayPal Email Address?";
      this.vip_email_label = "Your VIP Club Email Address";
    },
    setGerman() {
      this.$validator.localize("de", {
        attributes: {
          paypal_email: "E-Mail Adresse verschickt",
          vip_email: "VIP Club E-Mail Adresse",
          reimbursed_method: "Reinbursment Method",
          permalink: "Bewertungslink",
          order_id: "Bestellnummer",
          country: "Land",
          product: "ProduktnameAmazon",
        },
      });

      this.country_label = "Land";
      this.product_label = "ProduktnameAmazon";
      this.order_id_label = "Amazon Bestellnummer ";
      this.permalink_label = "Amazon Bewertungslink";
      this.reimbursed_method_label =
        "Wie möchtest du deine Rückerstattung erhalten";
      this.paypal_email_label = "E-Mail Adresse verschickt";
      this.vip_email_label = "Deine VIP Club E-Mail Adresse";
    },
    getProducts() {
      this.axios
        .post(
          window.ajax_object.ajax_url,
          Qs.stringify({
            action: "noni_get_products_public",
            ajax_nonce: window.ajax_object.ajax_nonce,
          })
        )
        .then((response) => response.data)
        .then((response) => {
          this.products = response;
        })
        .catch((error) => {
          Swal.fire({
            title: "Error",
            text: "An error occurred",
            type: "error",
          });
          console.log(error);
        })
        .finally(() => {});
    },
    send() {
      this.$validator.validate().then((result) => {
        if (result) {
          this.loading = true;

          this.axios
            .post(window.ajax_object.ajax_url, Qs.stringify(this.form))
            .then((response) => {
              if (response.data.success == true) {
                Swal.fire({
                  title: "Success",
                  text: response.data.message,
                  type: "success",
                });

                this.sent = true;
                var element = this.$refs["message"];
                var top = element.offsetTop;
                window.scrollTo(0, top);
              } else {
                Swal.fire({
                  title: "Error",
                  text: response.data.errors[0],
                  type: "error",
                });
              }
            })
            .catch((error) => {
              console.log(error);
              this.errored = true;
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          Swal.fire({
            title: "Error",
            text: "The form is invalid",
            type: "error",
          });
        }
      });
    },
  },
};
</script>
